export default {
      id: "calc-service-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#calc-service-usage",
      toString: function () {
        return this.url;
      }
    }